import { useState, ReactNode, useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
import Login from '../pages/auth/login';
// components
import LoadingScreen from '../components/LoadingScreen';
import VerifyCode from 'src/pages/auth/verify';
import { Brand } from 'src/@types/brand';
import { MyParsedURLQuery } from 'src/@types/@types';
// firestore
import { collection, doc, limit, onSnapshot, query } from 'firebase/firestore';
import { DB, FUNCTIONS } from 'src/contexts/FirebaseContext';
import { PATH_DASHBOARD, PATH_PAGE } from 'src/routes/paths';
import { useSnackbar } from 'notistack';
import SetupBrand from 'src/pages/dashboard/[brandID]/setup';
import Page404 from 'src/pages/404';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export default function BrandGuard({ children }: Props) {
  const { query } = useRouter();
  const { brandID } = query as MyParsedURLQuery;

  const [isLoading, setIsLoading] = useState(true);

  const [brand, setBrand] = useState<Brand>();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    console.log('getBrand on BrandGuard')
    // Check if user is brand owner
    const unsub = onSnapshot(doc(DB, "brands", brandID), (doc) => {
      if (doc.exists()) {
        setBrand({ id: doc.id, ...doc.data() } as Brand);
      } else {
        console.error("Brand not found");
        enqueueSnackbar("Brand not found", { variant: 'error' });
      }
      setIsLoading(false);
    },
    (error) => {
      console.error(error.message);
      enqueueSnackbar(error.message, { variant: 'error' });
      setIsLoading(false);
    });
    return unsub;
  }, [brandID]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!brand) {
    return <Page404 />;
  }

  if (!brand.setup_completed) {
    return <SetupBrand />
  }

  return <>{children}</>;
}
